<template>
  <div class="mx-auto">
    <div class="minHeightMainContent flex-col">
      <div v-if="!loading">
        <Checkbox
          v-for="(val, ind) in settingsArray"
          :key="ind"
          class="mt-6"
          :title="ind"
          parent-module="section-teacher"
          :modules-array="val"
          :table-head-array="tableHeadArray"
          @updateSettings="getSettings"
        />
      </div>
      <Loader v-else class="mt-28" :content="true" />
    </div>
  </div>
</template>

<script>
/**
 * @notes IMPORTANT NOTES
 * index ACTION FOR VIEW
 * create ACTION FOR MARK
 *  */
/* COMPONENTS */
import Checkbox from '@src/components/Settings/attandance-settings/PermissionSettingsCheckbox.vue'
import Loader from '@components/BaseComponent/Loader.vue'
import { removeExtraRolePermissions } from '@utils/permissions'

/* 3rd party Component */
import { mapActions, mapState } from 'vuex'

export default {
  components: {
    Checkbox,
    Loader,
  },
  page: {
    title: 'System Settings | Teacher Settings',
    meta: [
      {
        name: 'description',
        content: 'Teacher Settings',
      },
    ],
  },
  data: function () {
    return {
      settingsArray: [],
      tableHeadArray: ['Settings', 'View', 'Mark'],
      loading: false,
      excludeRoleSettings: ['section_admin'],
    }
  },

  computed: {
    ...mapState('layout', [
      'currentCampusScope',
      'currentSectionScope',
      'activeRole',
      'currentClassScope',
    ]),
  },
  watch: {
    currentCampusScope: {
      handler: function () {
        this.getSettings()
      },
      deep: true,
    },
    currentSectionScope: {
      handler: function () {
        this.getSettings()
      },
      deep: true,
    },
    currentClassScope: {
      handler() {
        this.getSettings()
      },
    },
    activeRole: {
      handler: function () {
        this.getSettings()
      },
      deep: true,
    },
  },
  mounted() {
    this.getSettings()
  },

  methods: {
    async getSettings() {
      this.loading = true
      const [res, err] = await this.getTeacherSettings()
      removeExtraRolePermissions(this.excludeRoleSettings, res.data)
      this.settingsArray = res.data
      this.loading = false
    },
    ...mapActions('settings', ['getTeacherSettings']),
  },
}
</script>
